import { type ServiceError } from 'gpcore-apikit/grpc/types';
import { useLocationStore } from 'gpcore-apikit/store/pinia/location';
import useNotifications from 'gpcore-uikit/composables/useNotifications';
import { computed } from 'vue';

export default () => {
  const locationStore = useLocationStore();

  const countriesList = computed(() => locationStore.countries);
  const countryOptions = computed(() => {
    const options = new Array<{ key: string; label: string }>();
    const countries = countriesList.value;
    countries.forEach((country) => {
      options.push({ key: country.countryCode, label: country.name });
    });

    return options;
  });

  const { addNotification } = useNotifications();
  const reloadCountries = () => {
    locationStore.reloadCountries().catch((error: ServiceError) => {
      addNotification({
        message: error.message,
        type: 'danger',
      });
    });
  };

  return {
    countriesList,
    countryOptions,
    reloadCountries,
  };
};
